import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import PrefillByMobileOutputComponent from '../output/PrefillByMobileOutputComponent';

const PrefillByMobileInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-phone', title: 'Prefill By Mobile', subtitle: 'Auto-fill borrower details from a mobile number via Surepass' }}
        fields={[
            { name: 'mobile', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
        ]}
        endpoint={{
            path: '/surepass/prefill/prefill-by-mobile',
            bodyMapper: (v, sid) => ({ mobile: v.mobile, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="prefill-by-mobile"
        submitLabel="Fetch Prefill"
        successSummary="Prefill fetched"
        errorSummary="Prefill failed"
        confirmHeader="Confirm prefill fetch"
        confirmAcceptLabel="Yes, fetch"
        pdfEndpoint={(reportId) => `/surepass/prefill/prefill-by-mobile/${reportId}/generate-pdf`}
        pdfPasswordHint='Last 4 digits of the mobile number + "MOB" (Example: if the mobile is 9876543210, password is 3210MOB)'
        outputComponent={PrefillByMobileOutputComponent}
    />
);

export default PrefillByMobileInputComponent;
